import { collapsedContainerClass } from './color-image-tiles/constants';
import { ensureSelectedColorIsVisible } from './color-image-tiles/ensure-selected-color-is-visible';
import { makeOnlyVisibleTilesClickable } from './color-image-tiles/make-only-visible-tiles-clickable';
import { restoreExpansionStatus } from './color-image-tiles/restore-expansion-status';
import { setupMoreColorsLink } from './color-image-tiles/setup-more-colors-link';
import { toggleVisibilityOfExpandLinkOnResize } from './color-image-tiles/toggle-visibility-of-expand-link-on-resize';
import { getCurrentMajorBreakpoint, MajorBreakpoint } from '../../_common/client/breakpoint';
import { restoreScrollPosition, storeScrollPositionAfterScrolling } from './scrollable-tiles/scroll-position-for-mobile';
import { trackDimensionSwipes } from './tracking/track-dimension-swipes';
import { scrollSelectedTileIntoView } from './scrollable-tiles/scroll-selected-tile-into-view';

export const setupDimensionTiles = (rootElement: HTMLElement) => {
    const storageKey = getStorageKey(rootElement);
    if (storageKey == null) return;
    if (getCurrentMajorBreakpoint() === MajorBreakpoint.Desktop) {
        handleVerticallyHiddenTiles(rootElement, storageKey);
    } else {
        handleHorizontallyHiddenTilesForAllScrollingContainers(rootElement, storageKey);
    }
};

function handleVerticallyHiddenTiles(rootElement: HTMLElement, storageKey: string) {
    const showMoreColorsLink = rootElement.querySelector<HTMLElement>('.js_pdp_dimension-selection__show-more-colors-link');
    if (showMoreColorsLink == null) return;
    const imageTilesContainer = rootElement.querySelector<HTMLElement>(`.${collapsedContainerClass}`);
    if (!imageTilesContainer) return;
    if (imageTilesContainer.scrollHeight > imageTilesContainer.clientHeight) {
        setupMoreColorsLink(showMoreColorsLink, imageTilesContainer, storageKey);
        ensureSelectedColorIsVisible(imageTilesContainer, showMoreColorsLink, storageKey);
        restoreExpansionStatus(showMoreColorsLink, imageTilesContainer, storageKey);
        makeOnlyVisibleTilesClickable(imageTilesContainer);
        toggleVisibilityOfExpandLinkOnResize(showMoreColorsLink);
    }
}

function handleHorizontallyHiddenTilesForAllScrollingContainers(rootElement: HTMLElement, storageKey: string) {
    const scrollableContainer = rootElement.querySelectorAll<HTMLElement>('.pdp_dimension-selection__values');
    scrollableContainer.forEach((container, index) => {
        handleHorizontallyHiddenTiles(container, `${storageKey}-${index}`);
    });
}

function handleHorizontallyHiddenTiles(tilesContainer: HTMLElement, storageKey: string) {
    if (tilesContainer.scrollWidth > tilesContainer.clientWidth) {
        storeScrollPositionAfterScrolling(tilesContainer, storageKey);
        restoreScrollPosition(tilesContainer, storageKey);
        scrollSelectedTileIntoView(tilesContainer);
        trackDimensionSwipes(tilesContainer);
    }
}

export function getStorageKey(rootElement: HTMLElement) {
    const offerId = rootElement.getAttribute('data-offer-id');
    const productId = rootElement.getAttribute('data-product-id');

    return !!offerId ? offerId : productId;
}
